import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { DataLoginService } from '../dataLogin/data-login.service';
import { MangoEventAnalyticsService } from '../mango-events-analytics/mango-events-analytics.service';
interface Config {
  a: string;
  b: string;
  c: string;
}

export type IPkSk = {
  pk: string;
  sk: string;
};
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(
    private http: HttpClient,
    private dataLogin: DataLoginService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService
  ) {}

  config(url: string, idModule: IPkSk, random_pass: string) {
    return new Promise<object | Array<object>>((resolve, reject) => {
      let valueKey = this.randomNumber(16);
      let urlConfig = `${url}/clients/frontend`;
      if (idModule && idModule?.pk) {
        urlConfig = `${urlConfig}?module_pk=${idModule.pk}&module_sk=${idModule.sk}`;
      }
      this.http
        .post<Config[] | Config>(urlConfig, {
          key: valueKey.toString(),
        })
        .subscribe(
          (config) => {
            if (!Array.isArray(config)) {
              const decripted = this.decrypt(
                config as Config,
                random_pass,
                valueKey.toString()
              );
              const data =
                JSON.parse(decripted?.data ? decripted?.data : '{}') || {};
              this.dataLogin.config(data);
              this.configureEventAnalytics(data);
              resolve(data);
            } else {
              const configs: Config[] = config as Config[];
              const data: any[] = [];
              configs.forEach((element) => {
                const decripted = this.decrypt(
                  element,
                  random_pass,
                  valueKey.toString()
                );
                data.push(
                  JSON.parse(decripted?.data ? decripted?.data : '{}') || {}
                );
              });
              this.dataLogin.config(data);
              this.configureEventAnalytics(data);
              resolve(data);
            }
          },
          (error) => {
            reject(new Error(error.message));
          }
        );
    });
  }
  private randomNumber(length: number) {
    return Math.floor(
      Math.pow(10, length - 1) +
        Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)
    );
  }

  private decrypt(
    config: { a: string; b: string; c: string },
    random_pass: string,
    valueKey: string
  ) {
    let data_a = config.a;
    var datos = forge.util.decode64(data_a);

    var encrypted_end = this.cypherData(random_pass, valueKey, datos);
    datos = encrypted_end.data;
    var myPrivKey = forge.pki.privateKeyFromPem(datos);
    let data_c = config.c;
    var decrypted = myPrivKey.decrypt(forge.util.decode64(data_c));
    let original = decrypted + config.b;
    return this.cypherDataDecode(random_pass, valueKey, original);
  }

  private cypherData(random_pass: string, valueKey: string, update: any) {
    var cipher = forge.cipher.createDecipher('AES-CBC', valueKey);
    cipher.start({ iv: random_pass });
    cipher.update(forge.util.createBuffer(update));
    cipher.finish();
    return cipher.output;
  }

  private cypherDataDecode(random_pass: string, valueKey: string, update: any) {
    var cipher = forge.cipher.createDecipher('AES-CBC', valueKey);
    cipher.start({ iv: random_pass });
    cipher.update(forge.util.createBuffer(forge.util.decode64(update)));
    cipher.finish();
    return cipher.output;
  }

  private configureEventAnalytics(data: any | any[]): void {
    if (Array.isArray(data)) {
      // Si es un array, buscar CONFIG_EVENT_ANALYTICS en el primer elemento
      // o buscar en todos los elementos
      const eventAnalyticsConfig = data.find(
        (item) => item?.CONFIG_EVENT_ANALYTICS
      )?.CONFIG_EVENT_ANALYTICS;

      if (eventAnalyticsConfig && Array.isArray(eventAnalyticsConfig)) {
        console.log('eventAnalyticsConfig', eventAnalyticsConfig);
        this.mangoEventAnalyticsService.setConfig(eventAnalyticsConfig);
      }
    } else {
      // Si es un objeto, buscar CONFIG_EVENT_ANALYTICS directamente
      if (
        data?.CONFIG_EVENT_ANALYTICS &&
        Array.isArray(data.CONFIG_EVENT_ANALYTICS)
      ) {
        this.mangoEventAnalyticsService.setConfig(data.CONFIG_EVENT_ANALYTICS);
      }
    }
  }
}
